/*
  NH Add to Cart -> cart drawer (10/8, drawer-first decision, matches Clear Digital).

  The custom buy boxes (nh-hub / nh-fobio / nh-mic) post a plain product form, so
  Add to Cart used to leave the PDP for /cart. This intercepts those forms, adds via
  the AJAX cart API, swaps in the freshly rendered cart drawer and opens it, the same
  way the theme's own quick add does (app.js renderContents). Any failure, including
  an out-of-stock error from Shopify, falls back to submitting the form normally, so
  the worst case is the old behavior: landing on /cart.
*/
(function () {
  if (window.nhAtcDrawer) return;
  window.nhAtcDrawer = true;

  var FORMS = ['nh-hub-product-form', 'nh-fobio-product-form', 'nh-mic-product-form'];

  function addUrl() {
    return (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
  }

  // The buy-box forms have an <input name="id"> (variant), which shadows form.id,
  // so always read the attribute.
  function formId(form) {
    return form && form.getAttribute ? form.getAttribute('id') : null;
  }
  function ours(form) {
    return FORMS.indexOf(formId(form)) !== -1;
  }

  function innerOf(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  // The Meta pixel (fbevents.js) catches the ATC click and calls
  // HTMLFormElement.prototype.submit on the form itself, which skips submit
  // listeners and navigates to /cart; the native submit event fires too. So for
  // these three forms only, both paths route into add(), and a per-form lock makes
  // sure just one of them adds to the cart. Every other form submits untouched.
  var nativeSubmit = HTMLFormElement.prototype.submit;

  function add(form) {
    if (form.__nhAtcBusy) return;
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer || typeof drawer.open !== 'function' || !window.fetch) {
      nativeSubmit.call(form);
      return;
    }
    form.__nhAtcBusy = true;
    var id = formId(form);
    var buttons = document.querySelectorAll('button[type="submit"][form="' + id + '"], #' + id + ' button[type="submit"]');
    buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });

    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    data.append('sections_url', window.location.pathname);

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'add failed');
        var html = res.sections && res.sections['cart-drawer'] && innerOf(res.sections['cart-drawer'], '.cart-drawer');
        if (html === null || html === undefined) throw new Error('no drawer html');
        var target = drawer.querySelector('.cart-drawer') || drawer;
        target.innerHTML = html;
        if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
        drawer.open();
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: res } }));
      })
      .catch(function (err) {
        console.warn('[nh-atc-drawer] falling back to a normal form post:', err);
        nativeSubmit.call(form);
      })
      .finally(function () {
        buttons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
        setTimeout(function () { form.__nhAtcBusy = false; }, 600);
      });
  }

  HTMLFormElement.prototype.submit = function () {
    if (ours(this)) return add(this);
    return nativeSubmit.apply(this, arguments);
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!ours(form)) return;
    event.preventDefault();
    add(form);
  });

})();
